export default __webpack_public_path__ + "static/media/search-icon.cf7175d2.svg";